import { render } from "./VueMention.vue?vue&type=template&id=2dcc128e&scoped=true"
import script from "./VueMention.vue?vue&type=script&lang=js"
export * from "./VueMention.vue?vue&type=script&lang=js"

import "./comment-comp-responsive.css?vue&type=style&index=0&id=2dcc128e&scoped=true&lang=css&external"
import "./VueMention.vue?vue&type=style&index=1&id=2dcc128e&lang=css"
import "./VueMention.vue?vue&type=style&index=2&id=2dcc128e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dcc128e"]])

export default __exports__